import React from 'react';
import {CAP_SEMANTIC} from 'Theme/capTokens';
import Strings from 'Utils/constants/Strings';

const Texts = {...Strings.ErrorBoundary};

const ErrorBoundary = (props) => {
  // This is the app's top-level crash fallback (react-error-boundary wraps
  // App — including ConfigProvider — in index.tsx), so it can render with no
  // antd theme context above it at all; theme.useToken() isn't reliable
  // here. Using the static brand error color directly instead of a hardcoded
  // 'red' keeps it consistent with the theme's colorError without depending
  // on ConfigProvider being mounted.
  return (
    <div role="alert">
      <p data-testid="error-alert">{Texts.SomethingWentWrong}</p>
      <pre style={{color: CAP_SEMANTIC.error}}>{props.error.message}</pre>
    </div>
  );
};

export default ErrorBoundary;
